import React from 'react'
import ReferenceChild from './reference'
import Contact from './contact'
import ThaiRedcross from './thaiRedcross'

const Reference = ({ props }) => {
    return (
        <>
            <div className="div-reference content-block p-3">
                <div className="block-title">บุคคลอ้างอิง</div>
                <div className='py-2'>
                    <ReferenceChild props={props} />
                </div>
                <div className='py-2'>
                    <Contact props={props} />
                </div>
                <div className='py-2'>
                    <ThaiRedcross props={props} />
                </div>
            </div>
        </>
    )
}

export default Reference